import React from 'react'

import { Helmet } from 'react-helmet'

import './fa-qs.css'

const FAQs = (props) => {
  return (
    <div className="fa-qs-container">
      <Helmet>
        <title>
          FutureHeirs | Faith-Based Non-Profit Empowering Future Leaders
        </title>
      </Helmet>
      <div className="fa-qs-fa-qs">
        <div className="fa-qs-frame211">
          <div className="fa-qs-frame12">
            <div className="fa-qs-frame15">
              <div className="fa-qs-frame162">
                <img
                  alt="VectorI372"
                  src="/external/vectori372-xku6.svg"
                  className="fa-qs-vector10"
                />
                <span className="fa-qs-text10">futureheirs</span>
              </div>
              <div className="fa-qs-frame81">
                <div className="fa-qs-frame6">
                  <span className="fa-qs-text11">Home</span>
                </div>
                <div className="fa-qs-frame7">
                  <span className="fa-qs-text12">About Us</span>
                </div>
                <div className="fa-qs-frame82">
                  <span className="fa-qs-text13">Contact Us</span>
                </div>
                <div className="fa-qs-frame9">
                  <span className="fa-qs-text14">Blog</span>
                </div>
              </div>
              <div className="fa-qs-component41">
                <span className="fa-qs-text15">Join Us</span>
              </div>
            </div>
            <div className="fa-qs-frame13">
              <div className="fa-qs-frame195">
                <img
                  alt="Line651709"
                  src="/external/line651709-6yx.svg"
                  className="fa-qs-line65"
                />
                <span className="fa-qs-text16">FAQs</span>
              </div>
              <span className="fa-qs-text17">
                Have questions? We&apos;ve got answers! Explore our FAQs to
                learn more about our programs, mission, and how you can get
                involved.
              </span>
            </div>
          </div>
          <img
            alt="Rectangle41709"
            src="/external/rectangle41709-zij.svg"
            className="fa-qs-rectangle4"
          />
          <div className="fa-qs-frame210">
            <span className="fa-qs-text18">Frequently Asked Questions</span>
            <div className="fa-qs-frame209">
              <div className="fa-qs-faq">
                <div className="fa-qs-frame197">
                  <div className="fa-qs-frame2001">
                    <span className="fa-qs-text19">
                      How is FutureHeirs different from other educational
                      non-profits?
                    </span>
                    <span className="fa-qs-text20">
                      Our unique approach integrates faith, cutting-edge
                      technology, and community-based learning. We don&apos;t
                      just provide education—we nurture whole persons equipped
                      to lead with purpose and transform their communities.
                    </span>
                  </div>
                  <div className="fa-qs-vuesaxboldminuscirlce1">
                    <div className="fa-qs-vuesaxboldminuscirlce2">
                      <div className="fa-qs-minuscirlce">
                        <img
                          alt="VectorI170"
                          src="/external/vectori170-eb1p.svg"
                          className="fa-qs-vector11"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="fa-qs-frame198">
                  <div className="fa-qs-frame2002">
                    <span className="fa-qs-text21">
                      Do students need to share our faith to participate?
                    </span>
                  </div>
                  <div className="fa-qs-vuesaxboldaddcircle1">
                    <div className="fa-qs-vuesaxboldaddcircle2">
                      <div className="fa-qs-addcircle1">
                        <img
                          alt="VectorI170"
                          src="/external/vectori170-acu8.svg"
                          className="fa-qs-vector12"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="fa-qs-frame199">
                  <div className="fa-qs-frame2003">
                    <span className="fa-qs-text22">
                      {' '}
                      How can I start a FutureHeirs program in my community?
                    </span>
                  </div>
                  <div className="fa-qs-vuesaxboldaddcircle3">
                    <div className="fa-qs-vuesaxboldaddcircle4">
                      <div className="fa-qs-addcircle2">
                        <img
                          alt="VectorI170"
                          src="/external/vectori170-b9sn.svg"
                          className="fa-qs-vector13"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="fa-qs-frame2004">
                  <div className="fa-qs-frame2005">
                    <span className="fa-qs-text23">
                      What age groups do you serve?
                    </span>
                  </div>
                  <div className="fa-qs-vuesaxboldaddcircle5">
                    <div className="fa-qs-vuesaxboldaddcircle6">
                      <div className="fa-qs-addcircle3">
                        <img
                          alt="VectorI170"
                          src="/external/vectori170-iebl.svg"
                          className="fa-qs-vector14"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="fa-qs-frame201">
                  <div className="fa-qs-frame2006">
                    <span className="fa-qs-text24">
                      How can I support FutureHeirs if I can&apos;t donate
                      financially?
                    </span>
                  </div>
                  <div className="fa-qs-vuesaxboldaddcircle7">
                    <div className="fa-qs-vuesaxboldaddcircle8">
                      <div className="fa-qs-addcircle4">
                        <img
                          alt="VectorI170"
                          src="/external/vectori170-v65j.svg"
                          className="fa-qs-vector15"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="fa-qs-frame208">
                <div className="fa-qs-frame207">
                  <span className="fa-qs-text25">
                    In what way can we help you?
                  </span>
                  <span className="fa-qs-text26">
                    Feel free to reach out to us with your enquiries
                  </span>
                </div>
                <img
                  alt="Line661701"
                  src="/external/line661701-5j6.svg"
                  className="fa-qs-line66"
                />
                <div className="fa-qs-frame2051">
                  <div className="fa-qs-frame206">
                    <div className="fa-qs-frame203">
                      <span className="fa-qs-text27">Name</span>
                      <div className="fa-qs-frame2021">
                        <span className="fa-qs-text28">Owolabi Taiwo</span>
                      </div>
                    </div>
                    <div className="fa-qs-frame204">
                      <span className="fa-qs-text29">Email</span>
                      <div className="fa-qs-frame2022">
                        <span className="fa-qs-text30">example@gmail.com</span>
                      </div>
                    </div>
                    <div className="fa-qs-frame2052">
                      <span className="fa-qs-text31">Write your question</span>
                      <div className="fa-qs-frame2023">
                        <span className="fa-qs-text32">Enter here...</span>
                      </div>
                    </div>
                  </div>
                  <div className="fa-qs-component42">
                    <span className="fa-qs-text33">Submit now</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="fa-qs-frame212">
          <div className="fa-qs-frame184">
            <div className="fa-qs-group107">
              <span className="fa-qs-text34">Company</span>
              <div className="fa-qs-frame2491">
                <span className="fa-qs-text35">Home</span>
                <span className="fa-qs-text36">About Us</span>
                <span className="fa-qs-text37">Contact Us</span>
                <span className="fa-qs-text38">Programs</span>
                <span className="fa-qs-text39">Approach</span>
              </div>
            </div>
            <div className="fa-qs-group106">
              <span className="fa-qs-text40">Quick Links</span>
              <div className="fa-qs-frame2492">
                <span className="fa-qs-text41">Partner with Us</span>
                <span className="fa-qs-text42">Volunteer</span>
                <span className="fa-qs-text43">Donate</span>
                <span className="fa-qs-text44">Blog</span>
              </div>
            </div>
            <div className="fa-qs-group105">
              <span className="fa-qs-text45">Terms and Policies</span>
              <div className="fa-qs-frame248">
                <span className="fa-qs-text46">Privacy Policy</span>
                <span className="fa-qs-text47">Terms and Conditions</span>
                <span className="fa-qs-text48">Feedback</span>
                <span className="fa-qs-text49">FAQs</span>
              </div>
            </div>
            <div className="fa-qs-group104">
              <span className="fa-qs-text50">Contact Information</span>
              <div className="fa-qs-group87">
                <span className="fa-qs-text51">connect@futureheirs.org</span>
                <div className="fa-qs-vuesaxboldsms1">
                  <div className="fa-qs-vuesaxboldsms2">
                    <div className="fa-qs-sms">
                      <img
                        alt="VectorI208"
                        src="/external/vectori208-fij.svg"
                        className="fa-qs-vector16"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="fa-qs-group88">
                <span className="fa-qs-text52">
                  123 Faith &amp; Innovation Way, Your City, State 12345
                </span>
                <div className="fa-qs-vuesaxboldlocation1">
                  <div className="fa-qs-vuesaxboldlocation2">
                    <img
                      alt="VectorI208"
                      src="/external/vectori208-u4y.svg"
                      className="fa-qs-vector17"
                    />
                  </div>
                </div>
              </div>
              <div className="fa-qs-group89">
                <span className="fa-qs-text53">(555) 123-4567</span>
                <div className="fa-qs-vuesaxboldcall1">
                  <div className="fa-qs-vuesaxboldcall2">
                    <div className="fa-qs-call">
                      <img
                        alt="VectorI208"
                        src="/external/vectori208-kcce.svg"
                        className="fa-qs-vector18"
                      />
                      <img
                        alt="VectorI208"
                        src="/external/vectori208-r2h.svg"
                        className="fa-qs-vector19"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <img
            alt="Line2I208"
            src="/external/line2i208-h6bn.svg"
            className="fa-qs-line2"
          />
          <div className="fa-qs-frame183">
            <div className="fa-qs-frame161">
              <img
                alt="VectorI208"
                src="/external/vectori208-webd.svg"
                className="fa-qs-vector20"
              />
              <span className="fa-qs-text54">futureheirs</span>
            </div>
            <div className="fa-qs-frame180">
              <span className="fa-qs-text55">Follow Us:</span>
              <div className="fa-qs-frame177">
                <div className="fa-qs-vuesaxboldfacebook1">
                  <div className="fa-qs-vuesaxboldfacebook2">
                    <div className="fa-qs-facebook">
                      <img
                        alt="VectorI208"
                        src="/external/vectori208-y9yn.svg"
                        className="fa-qs-vector21"
                      />
                    </div>
                  </div>
                </div>
                <img
                  alt="riinstagramfillI208"
                  src="/external/riinstagramfilli208-8khe.svg"
                  className="fa-qs-riinstagramfill"
                />
                <img
                  alt="pajamaslinkedinI208"
                  src="/external/pajamaslinkedini208-uxcm.svg"
                  className="fa-qs-pajamaslinkedin"
                />
                <img
                  alt="fa6brandssquarextwitterI208"
                  src="/external/fa6brandssquarextwitteri208-5x5.svg"
                  className="fa-qs-fa6brandssquarextwitter"
                />
                <div className="fa-qs-vuesaxboldyoutube1">
                  <div className="fa-qs-vuesaxboldyoutube2">
                    <div className="fa-qs-youtube">
                      <img
                        alt="VectorI208"
                        src="/external/vectori208-irj9.svg"
                        className="fa-qs-vector22"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FAQs
